import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { MultiplePathwaysSerivce } from 'src/app/core/services';

@Pipe({ name: 'program' })

export class ProgramPipe implements PipeTransform, OnDestroy {
    AvailablePrograms: any;
    subscription?: Subscription;

    constructor(private multiplePathwaysServices: MultiplePathwaysSerivce) {
        this.AvailablePrograms = this.multiplePathwaysServices._AvailablePrograms;
    } 

    transform(data: any) {
        if (data == null) return null;

        // if ($rootScope == null || $rootScope.appvars == null || $rootScope.appvars.AvailablePrograms == null || $rootScope.appvars.AvailablePrograms.length == 0) return data;
        if (this.AvailablePrograms == null || this.AvailablePrograms.length == 0) return data;

        for (var i = 0, j = this.AvailablePrograms.length; i < j; ++i) {
            if (this.AvailablePrograms[i].ProgramID == data) return this.AvailablePrograms[i].Description;
        }

        return data;
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
}